
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import { EnumSupportType } from '@xt/client/enums/activity'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class StudySystem extends Mixins(MixinsHomeClick) {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp['studySystem']

  tabList: Array<{
    key: string
    label: string
  }> = [
    {
      key: '1',
      label: '课堂的样子'
    },
    {
      key: '2',
      label: '在哪里上课'
    }
  ]

  currentTab: string = '1'

  support: EnumSupportType[] = [EnumSupportType.Mate, EnumSupportType.Teach, EnumSupportType.IT, EnumSupportType.Wenfang]

  change(key: string): void {
    if (!['1', '2'].includes(key) || this.currentTab === key) return

    this.currentTab = key
  }

  handleClick(item: EnumSupportType) {
    const event = this.dataSource[item]

    if (event) {
      this.onClickEvent(event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
